import React from "react"
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-gray-200", className)}
      {...props}
    />
  )
}

// Skeleton específico para cards de serviço
const ServiceCardSkeleton = React.memo(() => {
  return (
    <div className="text-center space-y-4 animate-fade-in-up">
      <div className="bg-white rounded-lg p-2 inline-block mb-4">
        <Skeleton className="w-80 h-56 rounded-lg" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5 mx-auto" />
        <Skeleton className="h-4 w-3/4 mx-auto" />
      </div>
      <Skeleton className="h-9 w-32 mx-auto rounded-full" />
    </div>
  );
});

ServiceCardSkeleton.displayName = 'ServiceCardSkeleton';

// Skeleton para seção de consultoria
const ConsultoriaSkeleton = React.memo(() => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div className="space-y-6">
        <Skeleton className="h-8 w-3/4" />
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
        <Skeleton className="h-6 w-2/3" />
        <Skeleton className="h-11 w-48 rounded-full" />
      </div>
      <div className="flex justify-center">
        <Skeleton className="w-96 h-80 rounded-lg" />
      </div>
    </div>
  );
});

ConsultoriaSkeleton.displayName = 'ConsultoriaSkeleton';

export { Skeleton, ServiceCardSkeleton, ConsultoriaSkeleton }
